// Config + identifiers for the in-app rating prompt (mobile native review +
// extension/webapp store redirect). No magic numbers/strings live in the
// feature code; everything tunable sits here.

// Engagement floor before we ever soft-ask (items = bookmarks + notes).
export const MIN_ITEMS = 10
export const MIN_ACCOUNT_AGE_DAYS = 3

// Re-ask cadence after a "maybe later" (dismiss without answering).
export const REASK_COOLDOWN_DAYS = 30
export const MAX_SHOWS = 3

// Staging builds (any client) shorten the re-ask cooldown to 3 minutes so the
// prompt can be exercised repeatedly. Production keeps REASK_COOLDOWN_DAYS.
// eslint-disable-next-line no-undef
export const IS_STAGING = typeof CONFIG !== 'undefined' && CONFIG?.sentry?.environment === 'staging'
export const REASK_COOLDOWN_MS = IS_STAGING
  ? 3 * 60 * 1000
  : REASK_COOLDOWN_DAYS * 24 * 60 * 60 * 1000

// Backend user-settings key holding the per-target state (stored as a JSON
// string in the existing {name, value}[] settings shape).
export const SETTINGS_KEY = 'ratingPrompt'

// Moments that may surface the rating soft-ask. Add a member here and call
// openModalFlow(RATING_TRIGGER.X) from that surface to opt a new page in.
export const RATING_TRIGGER = {
  ITEM_ADD_DETAILS: 'item_add_details',
}

// $bus events: analytics hooks.
export const EVENTS = {
  SHOWN: 'rating:shown',
  ACCEPTED: 'rating:accepted',
  DECLINED: 'rating:declined',
}

// Review targets. Native targets map to app stores; ext_* targets are the
// browser extension stores, shared by the extension popup AND the webapp
// running in that same browser (so rating via either path suppresses both).
export const TARGET = {
  IOS: 'ios',
  ANDROID: 'android',
  EXT_CHROME: 'ext_chrome',
  EXT_FIREFOX: 'ext_firefox',
  EXT_EDGE: 'ext_edge',
  EXT_SAFARI: 'ext_safari',
}

// Apple App ID, required by AppReview.openAppStore() on iOS (fallback path).
export const IOS_APP_ID = '1673761012'

// Maps a Bowser browser name -> extension target + storeLinks/config key.
// Edge first: Chromium Edge's UA also contains "chrome".
export const EXTENSION_BROWSERS = [
  { match: 'edge', target: TARGET.EXT_EDGE, linkKey: 'edge' },
  { match: 'chrome', target: TARGET.EXT_CHROME, linkKey: 'chrome' },
  { match: 'firefox', target: TARGET.EXT_FIREFOX, linkKey: 'firefox' },
  { match: 'safari', target: TARGET.EXT_SAFARI, linkKey: 'safari' },
]
